<template>
  <div v-if="hSize === 1" class="main-font-color h1">
    <slot />
  </div>
  <div v-else-if="hSize === 2" class="main-font-color h2">
    <slot />
  </div>
  <div v-else-if="hSize === 3" class="main-font-color h3">
    <slot />
  </div>
  <div v-else-if="hSize === 4" class="main-font-color h4">
    <slot />
  </div>
  <div v-else-if="hSize === 5" class="main-font-color h5">
    <slot />
  </div>
  <span v-else class="main-font-color">
    <slot />
  </span>
</template>

<script>
  export default {
    name: 'HTitle',
    props: {
      hSize: Number,
    },
  };
</script>

<style scoped>

</style>
